import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["active", "defaultOpen", "navItem", "onItemClick", "onOpenClick", "pathname", "settingsApp", "title", "track", "hasStagedChanges"];
import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import UIBadge from 'UIComponents/badge/UIBadge';
import UIBreakString from 'UIComponents/text/UIBreakString';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import NavItemRecord from 'settings-ui-nav/utils/NavItem';
import ConfirmLeaveModal from 'settings-ui-nav/components/tab-groups/LeaveTabModal';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NavItem = props => {
  const {
      active,
      defaultOpen,
      navItem,
      onItemClick,
      onOpenClick,
      pathname,
      settingsApp,
      title,
      track,
      hasStagedChanges
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const [shouldDisplayConfirmLeaveModal, setShouldDisplayConfirmLeaveModal] = useState(false);
  const EXTERNAL_NAV_ITEM_IDS = {
    'productUpdates-new': true,
    productUpdates: true
  };
  const matchesPath = pathname ? navItem.matchesPath(pathname) : false;
  const handleItemClick = useCallback(evt => {
    if (!onItemClick) {
      return;
    }
    if (typeof track === 'function') {
      track('settingsNavInteraction', {
        settingsGroup: navItem.settingsGroup,
        settingsLink: navItem.trackingScreen,
        settingsApp
      });
    }
    if (hasStagedChanges) {
      setShouldDisplayConfirmLeaveModal(true);
      evt.preventDefault();
    }
    onItemClick(evt, navItem);
  }, [navItem, onItemClick, settingsApp, track, hasStagedChanges]);
  if (navItem.children.length) {
    const onOpenChange = evt => {
      if (onOpenClick) {
        onOpenClick(navItem.label, evt.target.value);
      }
    };
    return /*#__PURE__*/_jsx(UISideNavItem, Object.assign({
      "data-selector-id": navItem.id,
      "data-selenium-id": navItem.label,
      defaultOpen: matchesPath || defaultOpen,
      onOpenChange: onOpenChange,
      title: /*#__PURE__*/_jsx(UIBreakString, {
        children: title
      })
    }, rest, {
      children: navItem.children.map(childNavItem => /*#__PURE__*/_jsx(NavItem, {
        navItem: childNavItem,
        onItemClick: onItemClick,
        pathname: pathname,
        title: /*#__PURE__*/_jsx(UIBreakString, {
          children: childNavItem.label
        }),
        track: track
      }, childNavItem.label))
    }), navItem.label);
  }
  let iconRight;
  if (navItem.isNew) {
    iconRight = /*#__PURE__*/_jsx(UIBadge, {
      use: "new",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "settings-ui-nav.new"
      })
    });
  } else if (navItem.isBeta) {
    iconRight = /*#__PURE__*/_jsx(UIBadge, {
      use: "beta",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "settings-ui-nav.beta"
      })
    });
  }
  const renderModal = () => {
    if (shouldDisplayConfirmLeaveModal && hasStagedChanges) {
      return /*#__PURE__*/_jsx(ConfirmLeaveModal, {
        onConfirm: () => {
          window.location.href = navItem.path;
        },
        onReject: () => setShouldDisplayConfirmLeaveModal(false)
      });
    }
    return null;
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderModal(), /*#__PURE__*/_jsx(UISideNavItem, {
      active: active || matchesPath,
      "data-selector-id": navItem.id,
      "data-selenium-id": navItem.label,
      href: navItem.path,
      iconRight: iconRight,
      onClick: handleItemClick,
      title: /*#__PURE__*/_jsx(UIBreakString, {
        children: title
      }),
      external: EXTERNAL_NAV_ITEM_IDS[navItem.id]
    })]
  });
};
NavItem.propTypes = {
  onItemClick: PropTypes.func,
  onOpenClick: PropTypes.func,
  navItem: PropTypes.instanceOf(NavItemRecord).isRequired,
  pathname: PropTypes.string,
  settingsApp: PropTypes.string,
  track: PropTypes.func
};
export default NavItem;